import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "className", "size"];
import * as React from 'react';
import { cn } from "../utils";
import { SearchInputVariant } from "./variants/search-input-variant";
import { jsx as _jsx } from "react/jsx-runtime";
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  if (variant === 'search') {
    // Define las clases de altura predeterminadas basadas en el tamaño
    var defaultHeightClass = size === 'sm' ? 'tw-h-4' : 'tw-h-5.6';

    // Verifica si `className` incluye alguna clase de altura
    var hasHeightClass = className ? className.split(' ').some(function (cls) {
      return cls.includes('tw-h');
    }) : false;
    return /*#__PURE__*/_jsx(SearchInputVariant, _objectSpread({
      ref: ref,
      className: cn('tw-input',
      // Solo agrega `defaultHeightClass` si `className` no incluye una clase de altura
      !hasHeightClass && defaultHeightClass, size === 'sm' ? 'tw-font-body4' : 'tw-font-body3 tw-text-1.6', className)
    }, props));
  }
  return /*#__PURE__*/_jsx("div", {
    className: "tw-relative tw-flex tw-items-center",
    children: /*#__PURE__*/_jsx("input", _objectSpread({
      ref: ref,
      className: cn('tw-input', size === 'sm' ? 'tw-h-4 tw-font-body4' : 'tw-h-5.6 tw-font-body3 tw-text-1.6', className)
    }, props))
  });
});
Input.displayName = 'Input';
export { Input };